import { getRoleOptionsFilter } from '@/constants/options/role.option';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [{ key: 'name', trans: 'name', defaultOperator: 'like' }],
        type: 'input',
        value: [],
    },
    {
        key: [
            { key: 'createdDate', trans: 'createdDate', defaultOperator: '=' },
        ],
        type: 'date',
        value: [],
    },
    {
        key: [{ key: 'role', trans: 'role', defaultOperator: '=' }],
        type: 'select',
        value: getRoleOptionsFilter(true),
    },
];
